import React from "react";
import "./Skeleton.css";

type SkeletonProps = {
  className?: string;
};
/**
 * A pulsing element to indicate content that is being fetched and to act as a
 * layout placeholder.
 *
 * This element is mostly unstyled, so you will need to apply your own className
 * to the element to achieve a desired style.
 *
 * Default style is a <div className="sr-skeleton" /> with
 * ```css
 * .sr-skeleton {
 *   height: 1em;
 *   border-radius: 8px;
 * }
 * ```
 *
 * @example
 * ```tsx
    import styled from "@emotion/styled/macro";
    import { SrSkeleton } from "@sunrun/experience/ui/components";
    const SmallSkeleton = styled(Skeleton)`
      margin-bottom: 1em;
    `;
    const BigSkeleton = styled(Skeleton)`
      height: 4em;
      margin-bottom: 1em;
    `
    return (<>
      <SmallSkeleton />
      <BigSkeleton />
    </>);
 * ```
 */
const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return <div className={`sr-skeleton ${className ?? ""}`}></div>;
};

export { Skeleton };
